import dynamic from 'next/dynamic';
import { type ComboBoxProps } from '@discover-ui/comboBox';
import isValidSort from '@discover-data/stores/hooks/sort/isValid';
import useSort from '@discover-data/stores/hooks/sort/useSort';
import { sortOptions, sortValues } from '@discover-data/stores/hooks/sort/sortOptions';
import { TrackProvider } from '@/components/analytics/context/AnalyticsContext';

const ComboBox = dynamic(() => import('@discover-ui/comboBox'));

export type SortSelectProps = Omit<
  ComboBoxProps,
  'options' | 'value' | 'setValue' | 'placeholder' | 'description'
>;

export default function SortSelect({ triggerProps, ...props }: SortSelectProps) {
  const [sort, setSort] = useSort();

  return (
    <TrackProvider button_name="sort picker">
      <ComboBox
        options={sortOptions.map((option) => ({ ...option, label: `${option.label} first` }))}
        value={sort}
        setValue={(value) => {
          if (isValidSort(value, sortValues)) {
            setSort(value);
          }
        }}
        placeholder="Sort By"
        description="Select the sort order from the list"
        triggerProps={triggerProps}
        {...props}
      />
    </TrackProvider>
  );
}
